import {getGETS} from "@js/globalFunctions/getGets";
import {getCookie, setCookie} from "@js/globalFunctions/cookieHandling";

$(document).ready(function() {
    var gets = getGETS();

    var hasBfError = ( typeof gets['bf-error'] !== 'undefined' && (gets['bf-error'] === '1' || gets['bf-error'] === '2') ) ? 1 : false;
    var bfErrorCookie = getCookie('hasExperiencedBfError');

    if( hasBfError !== false && bfErrorCookie !== '1' )
    {
        if( hasBfError === 1 )
        {
            setCookie('hasExperiencedBfError','1',2);

            alert(wpTranslatedStrings.errors.lodgingPageBookingflowError);
        }
    }

});
